/** `navigator.userAgentData` is not in TypeScript's DOM lib yet. */
type NavigatorWithUserAgentData = Navigator & {
  userAgentData?: { platform?: string };
};

/**
 * The platform the shortcut labels are written for, read once per call so a test
 * can pass its own. Safari and Firefox do not implement `userAgentData`, so the
 * user agent string stands in there. Empty when there is no `navigator` (SSR,
 * some test setups), which reads as non-Mac — the Ctrl label is the safer default.
 */
const currentPlatform = (): string => {
  if (typeof navigator === 'undefined') {
    return '';
  }
  return (
    (navigator as NavigatorWithUserAgentData).userAgentData?.platform ??
    navigator.userAgent
  );
};

const modifierName = (platform: string): string =>
  platform.toUpperCase().includes('MAC') ? 'Cmd' : 'Ctrl';

/**
 * Undo / redo chord text, OS-dependent. Shared by the toolbar tooltips and the
 * mapping controls popover so both name the same key. `inputController` accepts
 * either modifier on every platform, so this only chooses which one to advertise.
 */
export const undoShortcutLabel = (platform = currentPlatform()): string =>
  `${modifierName(platform)} Z`;

export const redoShortcutLabel = (platform = currentPlatform()): string =>
  `${modifierName(platform)} Shift Z`;
